import React from 'react';
import styled from 'styled-components';
import logoImage from 'assets/img/logo.png';

const StyledLogo = styled.img`
    padding: 1.1rem 0 1.2rem 0;
`;

const Logo = () => <StyledLogo src={logoImage} alt="mobilise" />;

export default Logo;
